import TrackRowWaveform from './components/Waveform/TrackRowWaveform';
import { usePlayer, usePlayerApi, withPlayer, withPlayerApi } from './hooks';
import Player from './Player.component';
import PlayerProvider from './Player.provider';

// Core exports for the player package
export {
// Main components
Player, PlayerProvider,
// Primary hooks for state and actions
usePlayer, usePlayerApi,
// Individual track waveform component for consumers
TrackRowWaveform,
// HOCs for compatibility with class components
withPlayer, withPlayerApi };